import * as angular from 'angular';

import { ConnectionRoutesConfig } from './connection.routes';
import { ConnectionService } from './connection.service';
import { ConnectionPermissionsModule } from '~/modules/org-settings/components/connection/connection-permissions/connection-permissions.module';
import { ConnectionQueryHeaderEditorComponent } from '~/modules/org-settings/components/connection/connection-query-header-editor/connection-query-header-editor.component';

/* prettier-ignore */
export const ConnectionModule = angular
  .module('connection', [
    ConnectionPermissionsModule,
  ])
  .config(ConnectionRoutesConfig)
  .service('ConnectionService', ConnectionService)
  .component('connectionQueryHeaderEditor', ConnectionQueryHeaderEditorComponent)
  .name;
